import { forwardRef } from 'react'
import { Root } from './Typography.styles'

// Mapping semántico de variants a tags
const VARIANT_TAGS = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle: 'p',
  body1: 'p',
  body2: 'p',
  caption: 'span',
  jumbo: 'div'
}

const Typography = forwardRef(({
  variant = 'body1',
  align = 'inherit',
  color,
  fontSize,
  fontWeight,
  lineHeight,
  italic = false,
  noWrap = false,
  margin,
  padding,
  width,
  display,
  children,
  ...restProps
}, ref) => {
  const ComponentTag = VARIANT_TAGS[variant] || 'p'

  return (
    <Root
      as={ComponentTag}
      ref={ref}
      variant={variant}
      align={align}
      color={color}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      italic={italic}
      noWrap={noWrap}
      margin={margin}
      padding={padding}
      width={width}
      display={display}
      {...restProps}
    >
      {children}
    </Root>
  )
})

export default Typography
